import { useLayoutEffect, useRef } from 'react';

function useAutosizeTextarea(value) {
    const textareaRef = useRef(null);

    useLayoutEffect(() => {
        const textarea = textareaRef.current;

        if (!textarea) {
            return undefined;
        }

        const resize = () => {
            const { borderTopWidth, borderBottomWidth } = window.getComputedStyle(textarea);
            const borderHeight = parseFloat(borderTopWidth) + parseFloat(borderBottomWidth);

            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight + borderHeight}px`;
        };

        resize();
        window.addEventListener('resize', resize);

        return () => window.removeEventListener('resize', resize);
    }, [value]);

    return textareaRef;
}

export {
    useAutosizeTextarea
};
